import React from 'react';
import { RichText } from 'prismic-reactjs';
import { get } from 'lodash';

const LLRCustomHero = slice => {
  console.log(slice, 'hi');
  const title = get(slice, 'primary.title');
  const subCopy = get(slice, 'primary.sub_copy');
  const backgroundImage = get(slice, 'primary.background_image.url');
  const llrImageMobile = get(slice, 'primary.llr_image_mobile.url');
  const llrImageDesktop = get(slice, 'primary.llr_image_desktop.url');
  const logo1 = get(slice, 'primary.logo_image_1.url');
  const logo2Desktop = get(slice, 'primary.logo_image_2.url');

  const backgroundStyle = {
    background: 'url(' + backgroundImage + ')'
  };

  return (
    <section className="newLLRHero">
      {backgroundStyle && <div className="background-image" style={backgroundStyle}></div>}

      <div className="logo-copy-wrapper">
        <figure className="logo1 relative">
          <img src={logo1} />
        </figure>
        <div className="copy-wrapper relative">
          <div className="mid-blue more-letterspacing ">
            <RichText render={title} />
          </div>
          <div className="light-blue-background sub-copy">
            <RichText render={subCopy} />
          </div>
        </div>
      </div>
      <figure className="vape">
        <img src={llrImageMobile} alt="llr vape cartridge with oil coming out from the top" />
      </figure>
      <figure className="cresco-logo">
        <img src={logo2Desktop} role="presentation" alt="" />
      </figure>
    </section>
  );
};

export default LLRCustomHero;
